if (!customElements.get('frame-finder-results-button')) {

    class FrameFinderResultsButton extends HTMLElement {
        constructor() {
            super();
            this.collectionUrl = this.dataset.collection;
            this.genderFilter = this.dataset.genderFilter;
            this.productTypeFilter = this.dataset.productTypeFilter;
        }

        connectedCallback() {
            this.initButton();
        }


        /**
         * Initialize the view results button and add an event listener for the click 
         */
        initButton() {
            this.addEventListener('click', (event) => {
                event.preventDefault();
                this.handleClick();
            })
        }


        /**
         * Retrieve the filters url based on the current answer history, then buil the new url
         * to filter the results, save it in a cookie and navigate to it
         */
        handleClick() {
            const filtersUrl = FrameFinderUtils.getFiltersUrl();
            let updatedUrl =  `${this.collectionUrl}?${filtersUrl}`;
            let productCount = 0;
            let textLabel = document.querySelector('#no-results-text');
            fetch(updatedUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.text(); 
                })
                .then(data => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(data, 'text/html');
                    const productCountElement = doc.querySelector('[data-collection-product-count]');
                    
                    productCount = Number(productCountElement?.dataset.collectionProductCount ?? 0);
                    
                    if (productCount === 0) {
                        localStorage.setItem('is-product-found', false);
                        updatedUrl = `${this.collectionUrl}?${this.getAlternativeUrl()}`;
                        this.setNoResultsCollectionText(textLabel);
                    } else {
                        localStorage.setItem('is-product-found', true);
                        updatedUrl = `${this.collectionUrl}?${filtersUrl}`;
                    }
                    CookieUtils.setCookie(FRAME_FINDER_KEYS.filteredUrlKey, updatedUrl);

                    window.location.href = updatedUrl;
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
          
        }

        getAlternativeUrl() {
            let filters = JSON.parse(localStorage.getItem(FRAME_FINDER_KEYS.localStorageKey)) || [];
            filters = filters.filter((obj) => obj[FRAME_FINDER_ANSWER_KEYS.filterName].includes(this.genderFilter) || obj[FRAME_FINDER_ANSWER_KEYS.filterName].includes(this.productTypeFilter));
            let alternativeFilters = [];
            filters.forEach((ansObj) => {
                ansObj[FRAME_FINDER_ANSWER_KEYS.filterValue].forEach((filterValue, index) => { 

                    if (filterValue != 'no-preference' && filterValue != '') {
                        alternativeFilters.push(`${ansObj[FRAME_FINDER_ANSWER_KEYS.filterName][index]}=${filterValue}`);
                    }
                });
            });
            const alternativeFiltersUrl = alternativeFilters.join('&');
            return alternativeFiltersUrl;
        }

        setNoResultsCollectionText(label) {
            console.log(label)
            const storageKey = 'noResultsLabel';
            localStorage.setItem(storageKey, label.dataset.copy);
            
            const savedText = localStorage.getItem(storageKey);
            this.textLabel = savedText ? savedText : label.dataset.copy;
            
            label.textContent = this.textLabel;
        }
    }

    customElements.define('frame-finder-results-button', FrameFinderResultsButton);
}